module.exports = __webpack_public_path__ + "img/pathology.961802a6.svg";